import type { FC } from "react";

import { ProductBatchUpdateForm } from "src/app/features/Product/components/forms/ProductBatchUpdateForm";
import { useProductBatchUpdateMutation } from "src/app/features/Product/services/server/ProductApi";
import type { ProductBatchUpdateEntity } from "src/app/features/Product/types/ProductBatchUpdateEntity";
import type { ProductEntity } from "src/app/features/Product/types/ProductEntity";
import { BatchUpdateDrawerButton } from "../../../../../components/DrawerForm/BatchUpdateDrawer/BatchUpdateDrawerButton";
import { useBatchUpdateDrawer } from "../../../../../components/DrawerForm/BatchUpdateDrawer/useBatchUpdateDrawer";
import type { ButtonProps } from "../../../../../components/FeatureButtons/types";

export const ProductBatchUpdateButton: FC<ButtonProps<ProductEntity>> = ({ isDisabled, items }) => {
    const [saveFormData] = useProductBatchUpdateMutation();
    const { open, form, isDisabledFinal, isSubmitting, showDrawer, onClose, onSubmit } = useBatchUpdateDrawer<
        ProductBatchUpdateEntity,
        ProductEntity
    >(items, isDisabled, saveFormData);

    return (
        <BatchUpdateDrawerButton
            isDisabled={isDisabledFinal}
            open={open}
            onOpen={showDrawer}
            onClose={onClose}
            isSubmitting={isSubmitting}
            titleKey="product.batchUpdate.header"
        >
            <ProductBatchUpdateForm form={form} searchCallback={onSubmit} />
        </BatchUpdateDrawerButton>
    );
};
